import { render, staticRenderFns } from "./wholesale-storegroups-update-button.vue?vue&type=template&id=372d4c00"
import script from "./wholesale-storegroups-update-button.vue?vue&type=script&lang=js"
export * from "./wholesale-storegroups-update-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports